import * as React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import {  CardHeader } from "@material-ui/core";
import Box from '@mui/material/Box';
interface SimpleCardType {
  heading: string;
  username: string;
  userID: string;
  productName: string;
  color: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 275,
      borderRadius: "",
      margin: "10px",
    },
    header: {
      borderRadius: "10px 10px 0px 0px",
      color: "white",
      padding: "8px",
    },
  })
);

export default function SimpleCard(props: SimpleCardType) {
  const classes = useStyles();

  return (
    <Card elevation={0}>
      <CardHeader
        className={classes.header}
        style={{ backgroundColor: `${props.color}` }}
        title={props.heading}
        titleTypographyProps={{ variant: "subtitle1" }}
      />
      <CardContent className="simpleCard">
        <Box component="div">
          <Typography variant="subtitle1" className="stLeft">
            User Name:{" "}
          </Typography>
          <Typography variant="subtitle2" display="inline">
            <strong>{props?.username}</strong>
          </Typography>
        </Box>
        <Box component="div">
          <Typography variant="subtitle1" className="stLeft">
            User ID:{" "}
          </Typography>
          <Typography variant="subtitle2" display="inline">
            <strong>{props?.userID}</strong>
          </Typography>
        </Box>
        <Box component="div">
          <Typography variant="subtitle1" className="stLeft">
            Product Name:{" "}
          </Typography>
          <Typography variant="subtitle2" display="inline">
            <strong> {props?.productName}</strong>
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
